import React from 'react'
import styles from './Home.module.css';

const Home = () => {
return (
    <div className={styles.home}>
        <div className={styles.container}>
            <div className={styles.title}>
                    <h2>human, who?</h2>
            </div>
            <div className={styles.text}>
                    <p>
                            Estratégias personalizadas para marcas<br />
                            que buscam crescer de forma acelerada:<br />
                            aumentar as suas <span className="underlineBold">
                            vendas <span className={styles.circle1}>e se posicionar</span>
                            </span><br />
                            além do óbvio. Desenvolvida em rede com<br />
                            criatividade por especialistas em marketing,<br />
                            inovação e tecnologia. 
                    </p>
            </div>
        </div>
        
        <div className={styles.container2}>
            <div className={styles.images}>
                    <img className={styles.imgHome} src="home1.png" alt="hero" />
                    <img className={styles.imgHome} src="home2.png" alt="hero" />
                    <img className={styles.imgHome} src="home3.png" alt="hero" />
            </div>
                <div className={styles.textIa}>
                    <p>Impulsionado por IA, feito com criatividade,<span class={styles.underline}> centrado no humano.</span></p>
                </div>
        </div>
    </div>
)
}

export default Home